import React, { useRef } from 'react';
import { string, bool } from 'prop-types';
import { Button } from '../../../../shared_modules/propulsion/components';

const Popup = ({ summaryTemplate, isPDFFile, url }) => {
  const iframeRef = useRef(null);

  // Set iframe height to the height of its contents to scroll seamlessly with the rest of the page
  // when iframe loads
  const iframeLoaded = () => {
    const iframeEl = iframeRef.current;
    iframeEl.style.height =
      iframeEl.contentWindow.document.body.clientHeight + 'px';
  };

  // Recalculate iframe height when the screen size changes
  window.addEventListener('resize', iframeLoaded);

  const handlePrint = () => {
    // Print only the content of the iFrame
    window['popup-page__agreement-frame'].print();
  };

  return (
    <div className="popup-page">
      <div className="popup-page__grid popup-page__content">
        <Button
          variant="primary"
          className="popup-page__floating-secondary-button"
          data-print-button
          onClick={handlePrint}
        >
          Print
        </Button>
        <Button
          variant="secondary"
          className="popup-page__floating-right-button"
          onClick={() => window.close()}
          data-close-button
          data-testid="close1"
        >
          Close
        </Button>
        <h1 className="popup-page__title">LendingClub</h1>
        {summaryTemplate && (
          <div className="popup-page-summary">{summaryTemplate}</div>
        )}
        {isPDFFile ? (
          <object
            width="100%"
            height="100%"
            className="popup-page__pdf"
            data={url}
            type="application/pdf"
          />
        ) : (
          <iframe
            ref={iframeRef}
            className="popup-page__agreement-frame"
            onLoad={iframeLoaded}
            src={url}
            name="popup-page__agreement-frame"
            width="100%"
            data-resizable-iframe
            data-heap-redact-text
          />
        )}
        <div className="popup-page__grid popup-page__bottom-button">
          <Button
            variant="secondary"
            onClick={() => window.close()}
            data-testid="close2"
            data-close-button
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

Popup.propTypes = {
  isPDFFile: bool,
  summaryTemplate: string,
  url: string
};

export default Popup;

require('/var/lib/jenkins/workspace/auto-borrower-apply-ui_Release_0/src/pages/popup/popup.scss');